import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostBinding,
  Inject,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges
} from '@angular/core';
import { AppStore } from '@iv/store/app.store';
import * as Redux from 'redux';
import { AppState } from '@iv/store/app.reducer';
import { getCurrentTab } from '@iv/store/tabs/tabs.selectors';
import {
  futHvModel,
  futIvxModel,
  hvModel,
  hvModelAlt,
  ivxModel,
  ivxModelAlt
} from './model/summary-line-table';
import { TabTypeEnum } from '@iv/model/tabs.model';
import { adoptTipPosition } from "@iv/shared/utils";

@Component({
  selector: 'iv-live-summary-line-table',
  templateUrl: './summary-line-table.component.html',
  styleUrls: ['./summary-line-table.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SummaryLineTableComponent implements OnInit, OnChanges {

  constructor(
    @Inject(AppStore) private store: Redux.Store<AppState>
  ) {
  }

  @Input()
  instrument = [];
  @Input()
  hv: number;
  @Input()
  ivx: number;
  @Input()
  data = [];
  @Input()
  columns = {};

  @Input()
  set visibleColumns(value: any[]) {
    this._visibleColumns = value;
    if (value && (value.length > 0)) {
      this.maxHeight = this.getMaxHeight();
    }
  }

  @Output()
  ivxLabelChange = new EventEmitter<any>();
  @Output()
  hvLabelChange = new EventEmitter<any>();
  @Output()
  IVXInit = new EventEmitter<any>();
  @Output()
  HVInit = new EventEmitter<any>();

  @HostBinding
  ('style.maxHeight') maxHeight = '100%';

  currentTab = getCurrentTab(this.store.getState());
  ivxLabel = '30';
  hvLabel = this.currentTab.type === TabTypeEnum.OPTION_CHAIN ? '20' : '30';
  ivpLabel = '30';
  hvpLabel = '20';
  HV: string[] = hvModel;
  IVX: string[] = ivxModelAlt;
  IVP: any[] = [
    '30',
    '60',
    '90'
  ];
  HVP: any[] = [
    '10',
    '20',
    '30',
    '60',
    '90',
    '120',
    '150',
    '180'
  ];
  regionId = this.currentTab.data[this.currentTab.type].regionId;
  showHvTip = true;
  showIvxTip = true;
  showHvpTip = true;
  showIvpTip = true;

  public ivxTip = `IVX is the composite measure of the ${this.currentTab.type === TabTypeEnum.OPTION_CHAIN ? 'stock\'s' : 'future underlying'}`;
  public hvTip = `${this.currentTab.type === TabTypeEnum.OPTION_CHAIN ? 'stock' : 'futures'}`;

  private _visibleColumns = [];
  private _frequency = {
    0: '',
    1: 'Annually',
    2: 'Semiannually',
    4: 'Quarterly',
    12: 'Monthly'
  };

  get visibleColumns(): any[] {
    return this._visibleColumns;
  }

  public ngOnInit(): void {
    if (this.currentTab.type === TabTypeEnum.FUTURES_OPTION_CHAIN) {
      this.IVX = futIvxModel;
      this.HV = futHvModel;
      this.HVInit.emit(this.HV);
      this.IVXInit.emit(this.IVX);
      return;
    }
    if (this.regionId === 1) this.IVX = ivxModel;
    if (this.regionId === 3) {
      this.HV = hvModelAlt;
      this.hvLabel = '30';
    }

    this.HVInit.emit(this.HV);
    this.IVXInit.emit(this.IVX);
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.hv?.currentValue !== changes.hv?.previousValue) {
      this.hvLabel = changes.hv.currentValue;
    }

    if (changes.ivx?.currentValue !== changes.ivx?.previousValue) {
      this.ivxLabel = changes.ivx.currentValue;
    }
  }

  getLabel(key) {
    if (this.columns[key]) {
      return this.columns[key].caption;
    }
    return key;
  }

  getValue(key) {
    return this.data[key] || '';
  }

  getFrequency(dividendFrequency: number): string {
    return this._frequency[dividendFrequency];
  }

  selectLabel(type, value) {
    this[type.toLowerCase() + 'Label'] = value;
    if ((type.toLowerCase() + 'Label') === 'ivxLabel') {
      this.ivxLabelChange.emit(value);
    }
    if ((type.toLowerCase() + 'Label') === 'hvLabel') {
      this.hvLabelChange.emit(value);
    }
  }

  showDropDown(type, showDropDown) {
    this['show' + type + 'Tip'] = !showDropDown;
  }

  getLabels() {
    const labels = [];
    if (this.visibleColumns && this.visibleColumns.length > 0) {
      for (const column in this.columns) {
        if (this.visibleColumns.indexOf(column) > -1) {
          labels.push(column);
        }
      }
    }
    return labels;
  }

  getMaxHeight() {
    if (this.visibleColumns === undefined) {
      return '0px';
    }
    if (this.visibleColumns.length <= 3) {
      return '48px';
    }
    return (((this.visibleColumns.length % 3) > 0)
      ? (Math.ceil(this.visibleColumns.length / 3) + 1)
      : (this.visibleColumns.length / 3)) * 48 + 'px';
  }

  onLabelMouseOver(event, element: any) {
    const tip = element.getElementsByClassName('tip')[0];
    const height = document.documentElement.clientHeight - event.clientY;
    if (tip) {
      if (height < (tip.clientHeight + 30)) {
        tip.style.top = 'auto';
        tip.style.bottom = tip.parentNode.clientHeight + 'px';
      } else {
        tip.style.top = tip.parentNode.clientHeight + 'px';
        tip.style.bottom = 'auto';
      }

      adoptTipPosition(tip);
    }
  }
}
